import { useQuery } from '@tanstack/vue-query';
import { useExperienceApi } from '@/shared/api/useExperienceApi.ts';
import { type MaybeRefOrGetter, unref } from 'vue';

export const useRegionInfo = (regionSlug: MaybeRefOrGetter<string>, enabled: MaybeRefOrGetter<boolean>) => {
  const { getRegionInfoBySlug } = useExperienceApi();

  const { data: regionInfo } = useQuery({
    queryKey: ['regionInfo', regionSlug],
    queryFn: () => {
      return getRegionInfoBySlug({ path: { regionSlug: unref(regionSlug) as string } });
    },
    enabled: computed(() => !!unref(enabled)),
    select: (response) => response.data,
    retry: false,
  });

  return {
    regionInfo,
  };
};
